export const ANALYTICS_EVENTS = {
  AUTH: {
    USER_LOGOUT_SUCCESS: 'User Logout Success',
    UNAUTHORIZED_ACCESS: 'Unauthorized Access',
  },

  SESSIONS: {
    USER_HEARTBEAT: 'User Heartbeat',
  },
  NAVIGATION: {
    PAGE_VIEWED: 'Page Viewed',
  },
};
